import { useEffect, useRef } from 'react';

const differentials = [
  { icon: 'ri-global-line', label: 'Estrutura Internacional' },
  { icon: 'ri-bit-coin-line', label: 'Operações com Criptomoedas' },
  { icon: 'ri-vip-crown-line', label: 'Atendimento Exclusivo' },
  { icon: 'ri-lock-2-line', label: 'Confidencialidade Total' },
  { icon: 'ri-links-line', label: 'Rede Global de Conexões' },
  { icon: 'ri-rocket-line', label: 'Alta Performance' },
];

const DifferentialsSection = () => {
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('opacity-100', 'translate-y-0');
            entry.target.classList.remove('opacity-0', 'translate-y-8');
          }
        });
      },
      { threshold: 0.1 }
    );
    ref.current?.querySelectorAll('.reveal').forEach((el) => observer.observe(el));
    return () => observer.disconnect();
  }, []);

  return (
    <section ref={ref} className="bg-[#0F172A] py-28 lg:py-36">
      <div className="max-w-6xl mx-auto px-6 lg:px-12">

        {/* Header */}
        <div className="reveal opacity-0 translate-y-8 transition-all duration-700 text-center mb-16">
          <span className="font-sans text-xs font-medium tracking-[0.3em] uppercase text-[#C9A96E] block mb-4">
            Por que nos escolher
          </span>
          <h2 className="font-serif text-4xl md:text-5xl font-light text-white mb-5">
            Diferenciais
          </h2>
          <p className="font-sans text-base font-light text-white/50 max-w-lg mx-auto leading-relaxed">
            Inteligência estratégica, conexões globais e discrição absoluta em cada operação.
          </p>
        </div>

        {/* Pills */}
        <div className="reveal opacity-0 translate-y-8 transition-all duration-700 delay-100 grid grid-cols-2 md:grid-cols-3 gap-4 max-w-3xl mx-auto w-full">
          {differentials.map((diff, i) => (
            <div
              key={i}
              className="group flex items-center justify-center gap-3 px-5 py-4 rounded-full border border-white/8 cursor-pointer transition-all duration-300 hover:border-[#C9A96E]/35 hover:bg-white/3 w-full overflow-hidden"
            >
              <div className="w-5 h-5 flex-shrink-0 flex items-center justify-center">
                <i className={`${diff.icon} text-[#C9A96E]/70 group-hover:text-[#C9A96E] text-base transition-colors duration-300`} />
              </div>
              <span className="font-sans text-sm font-light tracking-wide text-white/70 group-hover:text-white transition-colors duration-300 text-center leading-snug">
                {diff.label}
              </span>
            </div>
          ))}
        </div>

      </div>
    </section>
  );
};

export default DifferentialsSection;
